.panel-heading
    span.summary= summary
    span.title= title
.panel-body
